import { render, staticRenderFns } from "./WhistleBlower-fr.vue?vue&type=template&id=bd9e0bba&scoped=true&"
import script from "./WhistleBlower-fr.vue?vue&type=script&lang=js&"
export * from "./WhistleBlower-fr.vue?vue&type=script&lang=js&"
import style0 from "./WhistleBlower-fr.vue?vue&type=style&index=0&id=bd9e0bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9e0bba",
  null
  
)

export default component.exports